<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
    <mat-checkbox
      class="cursor-pointer pl-2.5"
      [checked]="checklistSelection.isSelected(node)"
      [disabled]="node.disabled || isDisabled"
      (change)="leafItemSelectionToggle(node)"
      >{{ node.item }}
    </mat-checkbox>
    <div class="mat-tree__columns">
      <span *ngFor="let column of node.columns">{{ column.grade }}</span>
    </div>
    <button mat-icon-button disabled></button>
  </mat-tree-node>

  <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
    <mat-checkbox
      class="pl-2.5"
      [checked]="descendantsAllSelected(node)"
      [indeterminate]="descendantsPartiallySelected(node)"
      [disabled]="node.disabled || isDisabled"
      (change)="itemSelectionToggle(node)"
      >{{ node.item }}
    </mat-checkbox>
    <button *ngIf="!isExpandedTree" mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.item">
      <svg-icon
        key="{{ treeControl.isExpanded(node) ? 'arrow-up' : 'arrow-down' }}"
        size="xs"
        (click)="descendantsAllSelected(node)"></svg-icon>
    </button>
  </mat-tree-node>
</mat-tree>
